<template>
    <div class="sic-field__upload-image-container">
        <img
                v-if="showPreview"
                :src="imagePreview"
                class="sic-field__img-preview">
        <div
                v-else
                class="sic-field__upload-image-field">
            <input
                    id="image-upload"
                    type="file"
                    accept="image/*"
                    placeholder="Upload photo"
                    class="sic-field__upload-image"
                    @change="getImage">
            <label for="image-upload">
                Upload photo
            </label>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      imageFile: "",
      showPreview: false,
      imagePreview: ""
    };
  },
  watch: {
    imageFile: function() {
      this.$emit("imageFile", this.imageFile);
    }
  },
  methods: {
    getImage: function(e) {
      this.readFile(e.target.files[0]);
    },
    readFile: function(file) {
      const reader = new FileReader();
      reader.addEventListener(
        "load",
        function() {
          this.showPreview = true;
          this.imagePreview = reader.result;
          this.imageFile = file;
        }.bind(this),
        false
      );
      if (file) {
        if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
          reader.readAsDataURL(file);
        }
      }
    }
  }
};
</script>

<style lang="scss">
.sic-field__upload-image-container {
  .sic-field__img-preview {
    width: 96px;
    height: 96px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
  }
  .sic-field__upload-image-field {
    .sic-field__upload-image {
      width: 0.1px;
      height: 0.1px;
      opacity: 0;
      overflow: hidden;
      position: absolute;
      z-index: -1;
    }
    .sic-field__upload-image + label {
      cursor: pointer;
      width: 96px;
      height: 96px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1rem;
      /*font-style: italic;*/
      border-radius: 100%;
      color: rgba(72, 72, 72, 0.9);
      border: solid 3px var(--white);
      box-shadow: 0 2px 4px 0 rgba(109, 109, 109, 0.5);
      background-color: #d8d8d8;
      text-align: center;
    }
  }
}
</style>
